import { createContext, useContext } from "react";

export const FiltersContext = createContext(null);
export const SetFiltersContext = createContext(() => null);
export const FiltersDataContext = createContext(() => null);
export const UpdateFiltersDataContext = createContext(() => null);

export function useFilters() {
  return useContext(FiltersContext);
}

export function useSetFilters() {
  return useContext(SetFiltersContext);
}

export function useFiltersData() {
  return useContext(FiltersDataContext);
}

export function useUpdateFiltersData() {
  return useContext(UpdateFiltersDataContext);
}
